import React from 'react'
import Image01 from "../assets/svg/mygroup.svg";
import { MdOutlineGroups } from 'react-icons/md';
import { BiPlus } from 'react-icons/bi';
import { BsPencilFill } from 'react-icons/bs';
import Popup from 'reactjs-popup';
import EditGroup from './Form/Others/EditGroup';
import GroupInfo from './GroupInfo';
import Image02 from "../assets/images/user.png";
import { formatNumber } from '../utils/dtos';


export default function GroupView({ data }) {
  return (
    <div className='pb-5'>
        <div className="relative mb-4">
            <div className='absolute top-0 l-0 w-full h-full rounded-xl' style={{
                backgroundColor: 'rgba(0,0,0,.6)'
            }}></div>
            <Popup
                position="right center"
                modal
                trigger={
                    <button className='py-2 absolute flex items-center gap-1 hover:text-black bottom-6  right-4 text-primary px-3 border-2 border-white bg-white text-xs font-semibold rounded'>
                        <BsPencilFill />
                        Edit
                    </button>
                }
                nested
                lockScroll
                contentStyle={{
                    borderRadius: "12px",
                    backgroundColor: "white",
                    width: "fit-content",
                    fontSize: "0.8rem",
                    maxHeight: "98%",
                    overflow: "auto",
                }}
            >
                {(close) =>
                    <EditGroup close={close} />
                }
            </Popup>
            <img src={data?.image || Image01} alt='' className='rounded-xl object-cover w-full h-48' srcSet="" />
        </div>
            <Popup
                position="right center"
                modal
                trigger={
                    <div className="flex cursor-pointer justify-between pb-2 items-center">
                        <div className='w-1/4' title='group title'>
                            <h4 className='text-lg font-semibold'>{data?.groupName}</h4>
                        </div>
                        <div className='w-2/4' title='group description'>
                            <p className='w-full text-sm truncate'>{data?.description}</p>
                        </div>
                    </div>
                }
                nested
                lockScroll
                contentStyle={{
                    borderRadius: "12px",
                    backgroundColor: "white",
                    width: "fit-content",
                    fontSize: "0.8rem",
                    maxHeight: "98%",
                    overflow: "auto",
                }}
            >
                {(close) =>
                    <GroupInfo close={close} />
                }
            </Popup>
        
        <div className="pb-4 flex justify-between items-center">
            <div className="flex gap-3 items-center">
                <div className="flex items-center justify-center">
                    {data?.members?.map((member) => {
                        if (member?.userId !== data.owner) {
                            return (data?.members.indexOf(member) <= 6) && (<img alt="" title={member?.firstName + " " + member?.lastName} key={data?.members.indexOf(member)} className={`w-12 h-12 cursor-pointer rounded-full border-gray-200 border-2 transform hover:scale-125 ${data?.members?.indexOf(member) !== 0 && '-ml-2'}`} src={member?.profilePicture || Image02} />)
                        }
                        return null;
                    })}
                </div>
                <div className="flex items-center">
                    <MdOutlineGroups className="text-sm text-primary" />
                    <p className="text-[12px] ml-1 hover:underline cursor-pointer">{formatNumber(data?.members?.length)} Members</p>
                </div>
            </div>

            <button className='py-2 px-3 border-2 border-primary hover:border-black hover:bg-black text-white bg-primary text-xs font-semibold rounded flex items-center gap-1'>
                <BiPlus className='text-white' />
                Invite
            </button>
        </div>
    </div>
  )
}
